import Badge from "@/components/Badge/Badge";
import React, { Fragment } from "react";
import { createSlots } from "utils/create-slots";

const CommerceBox = ({ isleasable, isfinancable, children }) => {
  const [
    title,
    price,
    monthlyPrice,
    discount,
    share,
    shareMobile,
    leasingInfo,
    offerNumber,
  ] = createSlots(
    [
      "title",
      "price",
      "monthlyPrice",
      "discount",
      "share",
      "shareMobile",
      "leasingInfo",
      "offerNumber",
    ],
    children
  );

  return (
    <div className="container">
      <div className="flex w-full items-center xl:mt-2 mt-24 md:mb-7 mb-6">
        <div className="w-full  mx-auto flex flex-wrap items-center  bg-white">
          <div className="lg:p-0 lg:mx-0  w-full">
            <div className="grid lg:grid-cols-12 grid-cols-2 lg:gap-1 w-full  lg:mt-4 mt-5 border-b-[1px] border-gray-300 lg:pb-7 pb-5 relative">
              {title && (
                <div className="w-full lg:col-span-4 flex flex-col justify-center  col-span-6  lg:border-r-[1px] border-gray-300 relative lg:mb-0 mb-4 xl:pt-2">
                  {title}
                  <div className="lg:hidden block absolute top-0 right-0 ">
                    {shareMobile}
                  </div>
                </div>
              )}
              {discount && (
                <div className=" col-span-6 lg:hidden flex  justify-start h-full pt-4 items-center">
                  <Badge
                    color="discount"
                    size="small"
                    className="min-w-[85px] xl:min-w-[125px] !text-2xl "
                  >
                    {discount}
                  </Badge>
                </div>
              )}

              <div className=" col-span-6 lg:hidden flex  justify-start h-full py-4 items-center !pb-6 -mt-3"></div>
              {price && (
                <div className="w-full lg:col-span-3 lg:border-r-[1px] border-r-[1px] border-gray-300 xl:pt-5 ">
                  <div className="flex flex-col w-fit md:mx-auto">
                    <p className="xl:text-2xl text-xs text-left  font-bold  pt-[4px] pb-[5px] ">
                      Sofortkaufpreis
                    </p>

                    <p className="text-alert font-bold xl:text-5xl text-3xl lg:text-center ">
                      {price}
                    </p>
                  </div>
                </div>
              )}

              <div className="w-full lg:col-span-3 flex-col items-baseline lg:border-r-[1px] h-full lg:border-l-0 border-gray-300 m-auto xl:pt-5 lg:pl-0 pl-[5%]">
                <div className="flex flex-col justify-center md:max-w-[unset] md:w-fit md:mx-auto max-w-[150px]  lg:ml-[23%] ml-[20%] whitespace-nowrap">
                  {monthlyPrice && (isleasable || isfinancable) && (
                    <Fragment>
                      <div className="md:pb-0 pb-[5px] ">
                        <p className="xl:text-2xl text-xs text-left font-bold  pt-[4px] lg:pb-[5px] lg:mr-6 lg:ml-0  ">
                          {!isfinancable && isleasable && "mtl. leasen"}
                          {isfinancable && "mtl. finanzieren"}
                        </p>
                      </div>
                      <div className="flex items-baseline justify-start">
                        <span className=" lg:text-2xl text-sm mr-3 text-alert">
                          ab
                        </span>
                        <p className="ml-1 text-alert  font-bold xl:text-5xl text-3xl">
                          {monthlyPrice}
                        </p>
                        {leasingInfo}
                      </div>{" "}
                    </Fragment>
                  )}
                </div>
              </div>

              <div className="col-span-2 lg:block hidden  border-l-[1px] lg:border-l-0 border-gray-300">
                <div className="flex flex-col lg:justify-evenly justify-between h-full py-4 items-end">
                  {discount && (
                    <Badge
                      color="discount"
                      size="small"
                      className="min-w-[85px] xl:min-w-[125px] 2xl:!text-3xl  xl:!text-2xl lg:!text-xl md:!text:xl !rounded-lg !px-6 !py-3"
                    >
                      {discount}
                    </Badge>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="w-full  flex lg:hidden border-b-[1px] border-gray-300 py-2 text-blue-dark">
              <small className="text-[10px] text-gray-600">{offerNumber}</small>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommerceBox;
